import { assign } from "xstate";
import * as T from "./types";
import { UploadContext } from "./types";

export const prepareImages = assign((context: UploadContext, event) => {
  const images: T.Images = { ...context.images };
  const progress: T.Progress = { ...context.progress };

  for (const result of event.data) {
    /* file name is not unique enough */
    const [name, extension] = result.file.name.split(".");
    const uid = `${name}-${result.file.lastModified}-${
      result.file.size
    }.${extension.toLowerCase()}`;

    if (
      context.images[uid] === undefined ||
      context.images[uid].uploaded === false
    ) {
      images[uid] = {
        ...context.images[uid],
        uid,
        name: result.file.name,
        extension: extension.toLowerCase(),
        handle: result.file,
        size: result.file.size,
        modified: result.file.lastModified,
        type: result.file.type,
        exif: result.exif,
        uploaded: false,
      };
      progress[uid] = { progress: 0, stats: null };
    } else {
      images[uid] = {
        ...context.images[uid],
        extension: extension.toLowerCase(),
      };

      if (context.images[uid].id != null && !context.images[uid].uploaded) {
        progress[uid] = { progress: 0, stats: null };
      }
    }
  }

  return {
    images,
    progress,
    adding: { total: 0, added: 0 },
  };
});

export const clearHandles = assign((context: UploadContext, event) => {
  const images = Object.values(context.images)
    .map((image) => ({
      ...image,
      handle: null,
    }))
    .reduce((images, image) => ({ ...images, [image.uid]: image }), {} as any);

  return {
    images,
    progress: {},
  };
});
export const applyIds = assign({
  images: (context: UploadContext, event) => {
    const images = { ...context.images };

    for (const image of event.data) {
      images[image.uid].id = image.id;
    }

    return images;
  },
});
export const completeUpload = assign((context: UploadContext, event) => {
  const progress = {
    ...context.progress,
    [event.id]: { progress: 1, stats: event.stats },
  };

  return {
    progress,
    images: {
      ...context.images,
      [event.id]: {
        ...context.images[event.id],
        uploaded: true,
      },
    },
  };
});

export const updateProgress = assign({
  progress: (context: UploadContext, event) => {
    if (event.progress === 1) {
      return context.progress;
    }

    return {
      ...context.progress,
      [event.id]: { progress: event.progress, stats: event.stats },
    };
  },
});

export const removeImages = assign((context: UploadContext, event) => {
  const retained: T.Images = {};
  const images = Object.values(context.images);

  for (const image of images) {
    if (event.uids.includes(image.uid) === false) {
      retained[image.uid] = image;
    }
  }

  return {
    ...context,
    files: context.files.filter((file) => {
      const [name, ext] = file.name.split(".");

      return (
        retained[`${name}-${file.lastModified}-${file.size}.${ext}`] !==
        undefined
      );
    }),
    images: retained,
    progress: {},
  };
});
